/**
 * @param wxid
 * @param chatWxid
 * @param chatChange 选中对话框的时候回调，默认选中也需要进行回调
 * @author Yaochao
 * @date 2022/2/16 17:06
 * @description
 */
import React, {useState, useEffect, useRef, forwardRef, useImperativeHandle, useCallback} from 'react'
import {Input, Select, Tooltip, Popover, Badge, Spin, Button, BackTop} from "antd"
import IconClean from "./iconfont/clean/clean";
import IconSearch from "../../iconfont/search";
import IconNoDisturbing from "./iconfont/noDisturbing/noDisturbing";
import CloudApi from "../cloud/cloud_api";
import Util from "../public/utils";
import Message from "../common/message";
import ZkModal from "../common/modal/zkModal";
import modal_warning from "../cloud/image/customer/groupsend/modal_warning.png";
import ZkFormItem from "../common/form/zkFormItem";
import IconAddLinkMan from "./iconfont/addLinkMan/addLinkMan";
import MyCustomer from "./common/myCustomer/myCustomer";
import MemberCompanies from "./common/memberCompanies/memberCompanies";
import IconDeletes from "../../iconfont/delete/deletes";
import AddressBook from "./common/addressBook/addressBook";
import defaultPersonage from "./image/chat/defaultPersonage.png"
import defaultGroupChat from "./image/chat/defaultGroupChat.png"
import RightClick from "./common/rightclick/rightclick";
import {Item} from "react-contexify";
import IconASession from "./iconfont/aSession/aSession";
import GlobalSearch from "./common/globalSearch/globalSearch";
import allEmpty from "./image/chat/allEmpty.png";
import noHead from "./image/chat/noHead.png";
import globalSearch from "../im/image/chat/globalSearch.png"
import IconExternal from "./iconfont/external/external";
import * as util from "util";
import PubSub from "pubsub-js";

const {Option} = Select;
let timer, soleId

const ConversationList = forwardRef((props, ref) => {
    const {wxid, chat_wxid, chatChange, getContent, getChatAvatar, fProps: fProps} = props
    const [data, setData] = useState([])//全部数据
    const [searchList, setSearchList] = useState({})//全部数据
    const [messageSwitch, setMessageSwitch] = useState('9')//全部数据
    const [filterData, setFilterData] = useState([]) //存放用来筛选的数据
    const [searchData, setSearchData] = useState([]) //存放用来筛选的数据
    const [chatCustomer, setChatCustomer] = useState(false)//搜索联系人的焦点事件
    const [inSearch, setInSearch] = useState(false)//搜索联系人的焦点事件
    const [searchName, setSearchName] = useState('')//搜索群聊或个人的名称
    const [loading, setLoading] = useState(true)//loading
    const [groupName, setGroupName] = useState('')//发起群聊弹框的搜索功能
    const [linkManData, setLinkManData] = useState([])//联系人数组
    const [selectLinkData, setSelectLinkData] = useState([])//选中的我的客户数组
    const [selectFirmData, setSelectFirmData] = useState([])//选中的企业客户的数组
    const [saveLoading, setSaveLoading] = useState(false)//点击创建群聊时的确定按钮
    const [unreadTotal, setUnreadTotal] = useState(0)//未读的总数
    const clearAllRef = useRef(null)//清空所有对话的弹框
    const aGroupChatRef = useRef(null)//发起群聊的弹框
    const myCustomerRef = useRef(null)//我的客户的弹框
    const myClientRef = useRef(null)//我的客户的组件弹框
    const memberCompaniesRef = useRef(null)//企业成员的弹框
    const frimDataRef = useRef(null)//企业成员的弹框
    const addressBookRef = useRef(null)//通讯录的弹框
    const addressListRef = useRef(null)//通讯录组件的ref
    const globalSearchModalRef = useRef(null)
    const inputRef = useRef(null)

    useEffect(() => {
        setLoading(true)
        if (wxid) {
            if (chat_wxid == '' || chat_wxid == null) {
                CloudApi.getChatList(wxid, (data) => {
                    let allData = data.list
                    let arr = allData.filter(item => item.isTop == 1)
                    let str = allData.filter(item => item.isTop == 0)
                    let newData = arr.concat(str)
                    newData && newData.forEach((item, index) => {
                        item.checked = false
                        if (index == 0) {
                            item.checked = true
                            item.unRead = 0
                            item.notReadMsgNum = 0
                            getContent(item)
                        }
                    })
                    setLoading(false)//
                    setData(newData)//全部数据
                    setFilterData(newData)//用来筛选使用的数据
                    setSearchData(newData)//用来筛选使用的数据
                }, () => {
                    setLoading(false)
                })
            } else {
                CloudApi.getChatList(wxid, (data) => {
                    let allData = data.list
                    let arr = allData.filter(item => item.isTop == 1)
                    let str = allData.filter(item => item.isTop == 0)
                    let newData = arr.concat(str)
                    let flag = newData.some(item => item.chat_wxid == chat_wxid) //查找有没有点击的这个会话
                    if (flag) {
                        newData && newData.forEach((item, index) => {
                            item.checked = false
                            if (item.chat_wxid == chat_wxid) {
                                item.checked = true
                                getContent(item)
                            }
                        })
                    } else {
                        let bodyData = {
                            wxid: wxid,
                            chat_wxid: chat_wxid,
                            isRoom: chat_wxid.startsWith('R') ? 2 : 1
                        }
                        CloudApi.getChatPostChat(bodyData, (list) => {
                            list.checked = true
                            newData.forEach(item => {
                                item.checked = false
                            })
                            newData.unshift(list)
                            getContent(list)
                        }, (error) => {
                            Message.warning(error.respMsg)
                        })
                    }
                    setLoading(false)
                    setData(newData)//全部数据
                    setFilterData(newData)//用来筛选使用的数据
                    setSearchData(newData)//用来筛选使用的数据
                }, () => {
                    setLoading(false)
                })
            }
        }
        setSelectLinkData([])
        setSelectFirmData([])
        setSearchName('')
        setMessageSwitch('9')
    }, [wxid])
    useEffect(() => {
    }, [data])
    const insideValue = useRef(null)
    const Click = useCallback((e) => {
        if (e.target && !insideValue.current.contains(e.target)) {
            chatCustomerBlur && chatCustomerBlur()
        }
    }, [chatCustomerBlur])

    useEffect(() => {
        window.addEventListener('click', Click, true)
        return () => {
            window.removeEventListener('click', Click, true)
        }
    }, [Click])

    useEffect(() => {
        let token = PubSub.subscribe('IM_CHAT_SEND_MESSAGE', (msg, pubSubData) => {
            let id = pubSubData.chat_wxid
            createSession(id, 1)
        });

        return () => {
            PubSub.unsubscribe(token);
        }
    }, [JSON.stringify(data)])

    //发起会话 isRoom: 1私聊, 2：群聊
    function createSession(chat_wxid, isRoom) {
        let hasSession = data.filter(el => el.chat_wxid == chat_wxid)//发起聊天先判断有没有在会话列表中
        if (hasSession.length > 0) {
            //有的话直接选中那个会话
            hasSession[0].checked = true
            getContent(hasSession[0])
        } else {
            //没有在新建
            let bodyData = {
                wxid: wxid,
                chat_wxid: chat_wxid,
                isRoom: isRoom
            }
            CloudApi.getChatPostChat(bodyData, (list) => {
                list.checked = true
                let newData = data
                newData.forEach(item => {
                    item.checked = false
                })
                newData.unshift(list)
                modifiedTotalData(newData)
                getContent(list)
            }, () => {
                // Message.error('发起聊天失败')
            })
        }
    }

    //接受新消息   消息快照
    function taskData(list) {
        let newData = [...data]
        let conversationId = list.data.conversationId
        newData.forEach((item, index) => {
            if (item.conversationId == conversationId) {
                item.lastMsg = list.data.msg
                item.notReadMsgNum = list.data.notReadMsgNum
                item.hasNoRead = list.data.hasNoRead
            }
        })
        let arr = newData.filter(el => el.conversationId == conversationId)
        let str = newData.filter(el => el.conversationId != conversationId)
        str.unshift(arr[0])
        if (arr.length > 0) {
            setData(str)
            setFilterData(str)//用来筛选使用的数据
        }
    }

    function updateSaveLoading(loading) {
        setSaveLoading(loading)
    }

    //新消息来了  没有置顶的放在顶部 有置顶的放在置顶的下面
    function newConversation(list) {
        let newData = [...data],// 原有的数据
            judge = 0;
        let flag = newData.some(item => item.conversationId == list.data.conversationId)
        if (!flag) {
            if (list.data.isTop == 1) {
                newData.unshift(list.data);
            } else if (list.data.isTop == 0) {
                newData.splice(0, 0, list.data)
            }
            let newChat_wxid = Util.getUrlArg('chat_wxid')
            newData.forEach((item) => {
                item.checked = false
                if (item.conversationId == list.data.conversationId) {
                    item.unRead = list.data.unRead
                    item.notReadMsgNum = list.data.notReadMsgNum
                }
                if (item.chat_wxid == newChat_wxid) {
                    item.checked = true
                    getContent(item)
                }
            })
            setData(newData)//更新总数据
            setFilterData(newData)//用来筛选使用的数据
        }
    }

    //修改群名称
    function modifyingGroupName(msg) {
        let newData = [...data]
        let id = msg.data.chat_wxid
        newData.forEach((item) => {
            if (item.chat_wxid == id) {
                item.name = msg.data.roomName
            }
        })
        setData(newData)
        setFilterData(newData)//用来筛选使用的数据
        setSearchData(newData)//用来筛选使用的数据
    }


    //回到顶部按钮
    function backToTop() {
        document.querySelector('.all_conversations').scrollTop = 0
    }

    //清空所有对话
    function clearAllConversations() {
        clearAllRef.current.show()
    }

    //点击清空聊天的弹框确认按钮
    function clearAll() {
        CloudApi.getChatClearChatList(wxid, () => {
            setData([])
            setFilterData([])//用来筛选使用的数据
            setSearchData([])//用来筛选使用的数据
            clearAllRef.current.hide()
        }, () => {
        })
    }

    //点击选中的对话
    function selectedDialogue(index, item, e) {
        getContent(item)
        let newData = [...data]
        newData.forEach((item, ind) => {
            if (index == ind) {
                item.notReadMsgNum = 0//选中的把未读消息清零
                item.unRead = 0 // 选中的消息变成已读
                item.hasNoRead = 0
                item.checked = true
            } else {
                item.checked = false
            }
        })
        setData(newData)
    }

    //获取焦点
    function chatCustomerFocus() {
        setChatCustomer(true)
        if (searchName == '') {
            document.querySelector('.into_global_status').style.display = 'block'
        } else {
            document.querySelector('.search_search_name').style.display = 'block'
        }
    }

    //失去焦点
    function chatCustomerBlur() {
        setChatCustomer(false)
        document.querySelector('.search_search_name').style.display = 'none'
        document.querySelector('.into_global_status').style.display = 'none'
    }

    useEffect(() => {
    }, [searchList])

    //搜索群聊或个人的名称
    function searchNameChange(e) {
        soleId = Util.randomString()
        let value = e.target.value
        if (value != '') {
            document.querySelector('.search_search_name').style.display = 'block'
            document.querySelector('.into_global_status').style.display = 'none'
        } else {
            document.querySelector('.search_search_name').style.display = 'none'
            document.querySelector('.into_global_status').style.display = 'block'
        }
        setSearchName(value)
        clearTimeout(timer)
        timer = setTimeout(() => {
            if (value != '') {
                CloudApi.chetMsgSearch({
                    keyword: value,
                    type: 0,
                    accountId: Number(wxid),
                    currentAccountId: Number(wxid),
                    randomString: soleId
                }, (data) => {
                    if (soleId == data.randomString) {
                        setSearchList(data)
                    }
                }, () => {
                })
            } else {
                setSearchList({})
            }
        }, 200)
    }


    //点击结束会话
    function endSession(id) {
        let bodyData = {
            wxid: wxid,
            chat_wxid: id
        }
        let newData = JSON.parse(JSON.stringify(data))
        CloudApi.getChatEndConveerSattion(bodyData, () => {
            newData.forEach((item, index) => {
                let prev = newData[index - 1] || '',
                    next = newData[index + 1] || '',
                    obj = item.chat_wxid == id ? Object.assign(prev || next, {
                        checked: true,
                        notReadMsgNum: 0,
                        unRead: 0
                    }) : {};
                item.chat_wxid == id && getContent(obj);
            })
            let endSession = newData.filter(item => item.chat_wxid != id)
            setData(endSession)//原数组
            setFilterData(endSession)//用来筛选使用的数据
        }, () => {
        })
    }

    //退出群聊
    function exitGroupChat(id) {
        let newData = [...data]
        let bodyData = {
            wxid: wxid,
            chat_wxid: id
        }
        CloudApi.getChatQuitRoom(bodyData, () => {
            endSession(id)//结束对话
        }, () => {
        })
    }

    //点击置顶
    function setTop(id, type) {
        let bodyData = {
            wxid: wxid,
            chat_wxid: id,
            radio: type == 0 ? 1 : 0
        }
        let newData = [...data]
        let newFilterData = [...filterData]
        CloudApi.getChatSetTop(bodyData, () => {
            newData.forEach((item) => {//改变原数组置顶 不置顶状态
                if (item.chat_wxid == id) {
                    item.isTop = type == 0 ? 1 : 0
                }
            })
            newFilterData.forEach((item) => {//改变拷贝的数组置顶 不置顶状态
                if (item.chat_wxid == id) {
                    item.isTop = type == 0 ? 1 : 0
                }
            })
            setData(newData)
            setFilterData(newFilterData)
        }, () => {
        })
    }

    //消息免打扰事件
    function notDisturbChange(id, type) {
        let bodyData = {
            wxid: wxid,
            chat_wxid: id,
            radio: type == 0 ? 1 : 0
        }
        let newData = [...data]
        CloudApi.getChatSetNotDisturb(bodyData, () => {
            newData.forEach((item, index) => {
                if (item.chat_wxid == id) {
                    item.notDisturb = type == 0 ? 1 : 0
                }
            })
            setData(newData)//全部数据
            setFilterData(newData)//用来筛选使用的数据
        }, () => {
        })
    }

    //标记未读
    function markUnread(id, type, e) {
        e = e || window.event;
        if (e.stopPropagation) { //W3C阻止冒泡方法
            e.stopPropagation();
        } else {
            e.cancelBubble = true; //IE阻止冒泡方法
        }
        let bodyData = {
            wxid: wxid,
            chat_wxid: id,
            radio: type == 0 ? 1 : 0
        }
        let newData = [...data]
        CloudApi.getChatSetUnRead(bodyData, () => {
            newData.forEach((item, index) => {
                if (item.chat_wxid == id) {
                    item.unRead = type == 0 ? 1 : 0
                    if (item.unRead == 1) {
                        item.notReadMsgNum = 1
                    } else {
                        item.notReadMsgNum = 0
                    }
                }
            })
            setData(newData)//全部数据
            setFilterData(newData)//用来筛选使用的数据
        }, () => {
        })
    }

    //下一个未读切换
    function nextUnread() {
        let newData = JSON.parse(JSON.stringify(data))
        let unreadData = newData.filter(item => item.notReadMsgNum > 0)
        if (unreadData.length > 0) {
            let id = unreadData[0].chat_wxid
            let nextData = [...data]
            nextData.forEach((item, index) => {
                if (item.chat_wxid == id) {
                    getContent(item)
                    item.notReadMsgNum = 0//选中的把未读消息清零
                    item.unRead = 0 // 选中的消息变成已读
                    item.checked = true
                } else {
                    item.checked = false
                }
            })
            if (document.querySelector('.all_conversations')) {
                document.querySelector('.all_conversations').scrollTo(0, document.getElementById(`chat${id}`).offsetTop)
            }
            setData(nextData)
            setFilterData(nextData)//用来筛选使用的数据
        }
    }

    function modifiedTotalData(data) {
        setData(data)
    }

    //发起群聊
    function aGroupChat() {
        aGroupChatRef.current.show()//打开发起群聊的弹框
    }

    //发起群聊的弹框确认按钮
    function aGroupChatQuery() {
        if (groupName == '') {
            Message.warning('请先填写群名称')
            updateSaveLoading(false)
        } else if (selectLinkData.length == 0 && selectFirmData.length == 0) {
            Message.warning('请选择成员')
            updateSaveLoading(false)
        } else {
            updateSaveLoading(true)
            let ids = []
            let groupCustomerData = selectLinkData.concat(selectFirmData)
            groupCustomerData.forEach((item) => {
                ids.push(item.customerId)
            })
            let bodyData = {
                wxid: wxid,
                roomName: groupName,
                ids
            }
            CloudApi.getChatCreateChatRoom(bodyData, () => {
                updateSaveLoading(false)
                aGroupChatRef.current.hide()
                setGroupName('')
                setSelectLinkData([])
                setSelectFirmData([])
            }, () => {
                updateSaveLoading(false)
            })
        }
    }

    //发起群聊弹框的Input的Change事件
    function groupNameChange(e) {
        let value = e.target.value
        setGroupName(value)
    }

    //点击我的客户按钮
    function myClient() {
        myCustomerRef.current.show()//打开我的客户的弹框
        aGroupChatRef.current.hide()//关闭发起群聊的弹框
        setTimeout(() => {
            myClientRef.current.getSelectData(selectLinkData)
        })
    }

    //点击我的客户确定按钮
    function myClientQuery() {
        if (myClientRef.current.exportData().length > 0) {
            setSelectLinkData(JSON.parse(JSON.stringify(myClientRef.current.exportData()))) //把选择我的客户的保存起来
        } else {
            setSelectLinkData([]) //把选择我的客户的保存起来
        }
        myCustomerRef.current.hide()//关闭我的客户的弹框
        aGroupChatRef.current.show()//打开发起群聊的弹框
    }

    //点击企业成员按钮
    function memberCompanies() {
        memberCompaniesRef.current.show()//打开企业成员的弹框
        aGroupChatRef.current.hide()//关闭发起群聊的弹框
        setTimeout(() => {
            frimDataRef.current.getSelectData(selectFirmData)
        })
    }

    //点击企业成员的确定按钮
    function memberCompaniesQuery() {
        if (frimDataRef.current.exportData().length > 0) {
            setSelectFirmData(JSON.parse(JSON.stringify(frimDataRef.current.exportData())))//把选择企业客户的保存起来
        } else {
            setSelectFirmData([])//把选择企业客户的保存起来
        }
        memberCompaniesRef.current.hide()//关闭企业成员的弹框
        aGroupChatRef.current.show()//打开发起群聊的弹框
    }


    //删除选中的联系人
    function deleteFirm(index) {
        //外面展示的数组
        let newSelectFirmData = [...selectFirmData]
        newSelectFirmData.splice(index, 1)
        setSelectFirmData(newSelectFirmData)
    }

    //点击发起群聊中的删除我的客户的删除事件
    function deleteLinkData(index) {
        let newSelectLinkData = [...selectLinkData]
        newSelectLinkData.splice(index, 1)
        setSelectLinkData(newSelectLinkData)
    }

    useImperativeHandle(ref, () => ({
        taskData: taskData,
        newConversation: newConversation,
        nextUnread: nextUnread, //下一个未读 方法
        endSession: endSession, // 未读数量
        modifyingGroupName: modifyingGroupName,//修改群昵称
    }));

    function getItems(item, index) {
        return (
            <>
                <Item onClick={setTop.bind(this, item.chat_wxid, item.isTop)}>{item.isTop == 1 ? '取消置顶' : '置顶'}</Item>
                <Item
                    onClick={markUnread.bind(this, item.chat_wxid, item.unRead)}>{item.unRead == 0 ? '标记未读' : '标记已读'}</Item>
                <Item
                    onClick={notDisturbChange.bind(this, item.chat_wxid, item.notDisturb)}>{item.notDisturb == 1 ? '新消息提醒' : '消息免打扰'}</Item>
                <Item onClick={endSession.bind(this, item.chat_wxid, index)}>结束对话</Item>
                {item.isRoom == 1 ? <Item
                    onClick={exitGroupChat.bind(this, item.chat_wxid)}>{item.isRoom == 1 ? '退出群聊' : ''}</Item> : ''}
            </>
        )
    }

    //点击通讯录按钮展开弹框
    function addressBook() {
        addressBookRef.current.show()//打开通讯录的弹框
        let newData = [...data]//获取左侧全部的聊天列表
        newData.forEach((item) => {//把选中的全部取消掉
            item.checked = false
        })
        setData(newData)
        setTimeout(() => {
            addressListRef.current.setClick(false)
        })
    }

    //点击我的客户取消或者右上角的X按钮
    function selectCustomerCancel() {
        myCustomerRef.current.hide()//关闭我的客户弹框
        aGroupChatRef.current.show()//打开发起群聊的弹框
    }

    //点击企业成员取消或者右上角X的按钮
    function selectFirmCustomerCancel() {
        memberCompaniesRef.current.hide()//关闭企业成员的弹框
        aGroupChatRef.current.show()//打开发起群聊的弹框
    }

    //点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
    function openFilterBox(type, keyword, accountId, currentAccountId) {
        globalSearchModalRef.current.openGlobalSearchModal(type, keyword, accountId, currentAccountId)
        chatCustomerBlur()
    }

    //修改页面的路由
    function modificationChatWxid(accountId, friendId) {
        fProps.history.replace(Util.stitchingPath('/im/chat', {
            wxid: accountId,
            chat_wxid: friendId
        }))
    }

    //在左侧点击搜索的内容切换
    function clickJump(contactId, sessionId, type) {
        //contactId 联系人id（wxid）
        //sessionId 会话id（chat_wxid）
        //type     1单聊 2群聊
        CloudApi.getChatList(contactId, (data) => {
            let allData = data.list
            let arr = allData.filter(item => item.isTop == 1)
            let str = allData.filter(item => item.isTop == 0)
            let newData = []
            newData = arr.concat(str)
            setLoading(false)
            setData(newData,)//全部数据
            let flag = newData.some(item => item.chat_wxid == sessionId) //查找有没有点击的这个会话
            if (flag) {   //如果有 直接打开
                newData.forEach(item => {
                    item.checke = false
                    if (item.chat_wxid == sessionId) {
                        item.notReadMsgNum = 0//选中的把未读消息清零
                        item.unRead = 0 // 选中的消息变成已读
                        item.hasNoRead = 0
                        item.checked = true
                        getContent(item)
                    }
                })
                if (document.querySelector('.all_conversations')) {
                    document.querySelector('.all_conversations').scrollTo(0, document.getElementById(`chat${sessionId}`).offsetTop)
                }
            } else { //没有  就去发起聊天接口
                let bodyData = {
                    wxid: contactId,
                    chat_wxid: sessionId,
                    isRoom: type
                }
                CloudApi.getChatPostChat(bodyData, (list) => {
                    list.checked = true
                    newData.forEach(item => {
                        item.checked = false
                    })
                    newData.unshift(list)
                    getContent(list)
                }, (error) => {
                    Message.warning(error.respMsg)
                })
            }
            setData(newData)
            chatCustomerBlur()
        }, () => {
            setLoading(false)
        })
    }

    //点击聊天记录的内容
    function chatHistoryClick(item) {
        if (item.msgNum > 1) { //如果有多条消息记录 跳弹框
            globalSearchModalRef.current.openGlobalSearchModal(3, searchName, item.accountId, item.id)
        } else { //如果有一条直接打开
            clickJump(item.accountId, item.id, item.type)
        }
    }

    function messageSwitching(e) {
        setSearchName('')
        setMessageSwitch(e)
        let newData = [...filterData]
        if (e == 0) {//0 私聊消息
            let filterData = newData.filter(item => item.isRoom == e)
            setData(filterData)
            setSearchData(filterData)
        } else if (e == 1) {//1 群聊消息
            let filterData = newData.filter(item => item.isRoom == e)
            setData(filterData)
            setSearchData(filterData)
        } else if (e == 9) {//9 全部消息
            setData(newData)
            setSearchData(newData)
        }
    }

    return (
        <div className={'conversations_sidebar'} ref={insideValue}>
            <div className={'conversations_sidebar_select'}>
                <div className={'new_search_chat'}>
                    <Input
                        ref={inputRef}
                        className={chatCustomer ? 'chat_customer_name' : ''}
                        prefix={<IconSearch/>}
                        placeholder={'搜索'}
                        allowClear
                        bordered={chatCustomer}
                        onFocus={() => {
                            setInSearch(true)
                            chatCustomerFocus();
                        }}//获取焦点
                        onBlur={() => {
                            setInSearch(false)
                        }}//失去焦点
                        value={searchName}
                        onChange={searchNameChange}
                    />
                    {
                        !inSearch ? <Select
                            className={'select_chat_type'}
                            defaultValue='9'
                            bordered={false}
                            value={messageSwitch}
                            onChange={messageSwitching}
                        >
                            <Option value="9">全部聊天</Option>
                            <Option value="0">私聊</Option>
                            <Option value="1">群聊</Option>
                        </Select> : <></>
                    }
                    <Popover overlayClassName={'session_chat'} trigger="hover" placement="bottom" content={<ul>
                        <li onClick={aGroupChat}>发起群聊</li>
                        <li onClick={addressBook}>发起聊天</li>
                    </ul>}>
                        <span className={'sponsor_chat'}><IconASession/></span>
                    </Popover>
                    <GlobalSearch ref={globalSearchModalRef} inputRef={chatCustomerBlur} clickJump={clickJump}
                                  modificationChatWxid={modificationChatWxid}>
                        <div className={'show_global_status into_global_status'}
                            // 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
                             onClick={openFilterBox.bind(this, '0', searchName, wxid, wxid)}
                        />
                    </GlobalSearch>
                    <div className={'search_search_name'}>
                        {JSON.stringify(searchList) == '{}' ?
                            <img src={allEmpty} className={'global_modal_content_empty outside_empty'}/> :
                            <div className={'all_link_man'}>
                                {searchList.friendList && searchList.friendList.length > 0 ?
                                    <ul>
                                        <span style={{
                                            paddingLeft: '12px',
                                            boxSizing: 'border-box',
                                            marginTop: '16px'
                                        }}>联系人</span>
                                        {searchList.friendList && searchList.friendList.map((item, index) => {
                                            if (index < 3) {
                                                return <li key={index} style={{padding: '10px 12px'}}
                                                           onClick={clickJump.bind(this, item.accountId, item.friendId, 1)}>
                                                    {
                                                        item.avatar ? <img src={item.avatar}/> :
                                                            <img src={noHead}/>
                                                    }
                                                    <div className={'left_link_man'} style={{height: '40px'}}>
                                                        <span>
                                                            <span className={'left_link_man_name_style'}
                                                                  style={{maxWidth: '138px'}}
                                                                  dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', searchName)}}></span>
                                                            {item.friendType == 1 ?
                                                                <span className={'wx_name'}
                                                                      style={{fontSize: '12px'}}>@微信</span> : ''}
                                                        </span>
                                                        <span>
                                                            {item.friendType == 1 ?
                                                                <span style={{display: 'flex', alignItems: 'center'}}>微信昵称：<span
                                                                    style={{maxWidth: '115px'}}
                                                                    className={'left_link_man_name_style'}
                                                                    dangerouslySetInnerHTML={{__html: Util.textHightLight(item.nickName || '', searchName)}}></span></span> :
                                                                <span className={'a_line_display'}
                                                                      dangerouslySetInnerHTML={{__html: Util.textHightLight(item.corpName || '', searchName)}}></span>}
                                                        </span>
                                                    </div>
                                                </li>
                                            }
                                        })}
                                        {
                                            searchList.friendList && searchList.friendList.length >= 3 ?
                                                <GlobalSearch ref={globalSearchModalRef} ref={globalSearchModalRef}
                                                              inputRef={chatCustomerBlur} clickJump={clickJump}
                                                              modificationChatWxid={modificationChatWxid}>
                                                    <span className={'reverl_all'}
                                                          style={{
                                                              color: '#1673FF',
                                                              paddingLeft: '12px',
                                                              boxSizing: 'border-box'
                                                          }}
                                                        // 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
                                                          onClick={openFilterBox.bind(this, '1', searchName, wxid, wxid)}
                                                    >查看全部</span>
                                                </GlobalSearch> : ''
                                        }
                                        <div className={'global_search_line'}
                                             style={{margin: '16px 12px 0', width: 'calc(100% - 24px)'}}></div>
                                    </ul> : ''}
                                {
                                    searchList.roomList && searchList.roomList.length > 0 ?
                                        <ul>
                                            <span style={{
                                                marginTop: '14px',
                                                paddingLeft: '12px',
                                                boxSizing: 'border-box'
                                            }}>群聊</span>
                                            {searchList.roomList && searchList.roomList.map((item, index) => {
                                                if (index < 3) {
                                                    return <li key={index} style={{padding: '10px 12px'}}
                                                               onClick={clickJump.bind(this, item.accountId, item.roomId, 2)}>
                                                        {
                                                            item.avatar ? <img src={item.avatar}/> : <img src={noHead}/>
                                                        }
                                                        <div style={{height: '40px'}}>
                                                            <span style={{display: 'flex'}}>
                                                                <span style={{maxWidth: '105px'}}
                                                                      className={'left_link_man_name_style'}
                                                                      dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', searchName)}}></span>
                                                                {item.memberNum ? <span
                                                                    className={'group_member_num'}>（{item.memberNum}）</span> : ''}
                                                                {item.roomType == 0 ?
                                                                    <span></span> : item.roomType == 1 ?
                                                                        <span
                                                                            className={'external_icon'}><IconExternal/></span> : ''}</span>
                                                            <span style={{display: 'flex', alignItems: 'center'}}>
                                                                {item.memberName != '' ? '包含：' : ''}
                                                                <span style={{maxWidth: '140px'}}
                                                                      className={'left_link_man_name_style'}
                                                                      dangerouslySetInnerHTML={{__html: Util.textHightLight(item.memberName || '', searchName)}}></span>
                                                            </span>
                                                        </div>
                                                    </li>
                                                }
                                            })}
                                            {
                                                searchList.roomList && searchList.roomList.length >= 3 ?
                                                    <GlobalSearch ref={globalSearchModalRef}
                                                                  inputRef={chatCustomerBlur}
                                                                  clickJump={clickJump}
                                                                  modificationChatWxid={modificationChatWxid}
                                                    >
                                                        <span className={'reverl_all'}
                                                              style={{
                                                                  color: '#1673FF',
                                                                  paddingLeft: '12px',
                                                                  boxSizing: 'border-box'
                                                              }}
                                                            // 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
                                                              onClick={openFilterBox.bind(this, '2', searchName, wxid, wxid)}
                                                        >查看全部</span>
                                                    </GlobalSearch> : ''
                                            }
                                            <div className={'global_search_line'}
                                                 style={{margin: '16px 12px 0', width: 'calc(100% - 24px)'}}></div>
                                        </ul> : ''
                                }
                                {
                                    searchList.msgList && searchList.msgList.length > 0 ?
                                        <ul>
                                            <span style={{
                                                marginTop: '14px',
                                                paddingLeft: '12px',
                                                boxSizing: 'border-box'
                                            }}>聊天记录</span>
                                            {searchList.msgList && searchList.msgList.map((item, index) => {
                                                if (index < 3) {
                                                    return <li key={index} style={{padding: '10px 12px'}}
                                                               onClick={chatHistoryClick.bind(this, item)}>
                                                        {
                                                            item.avatar ? <img src={item.avatar}/> : <img src={noHead}/>
                                                        }
                                                        {
                                                            item.type == 1 ? <div style={{height: '40px'}}>
                                                                    <span
                                                                        style={{display: 'flex', alignItems: 'center'}}>
                                                                        <span style={{maxWidth: '135px'}}
                                                                              className={'left_link_man_name_style'}
                                                                              dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', searchName)}}></span>
                                                                        {item.friendType == 1 ?
                                                                            <span className={'wx_name'}
                                                                                  style={{fontSize: '12px'}}>@微信</span> : ''}
                                                                    </span>
                                                                    <span style={{maxWidth: '174px'}}
                                                                          className={'left_link_man_name_style'}>{item.msgNum}条相关聊天记录</span>
                                                                </div> :
                                                                item.type == 2 ?
                                                                    <div style={{height: '40px'}}>
                                                                        <span style={{maxWidth: '174px'}}
                                                                              className={'left_link_man_name_style'}
                                                                              dangerouslySetInnerHTML={{__html: Util.textHightLight(item.name || '', searchName)}}></span>
                                                                        <span style={{maxWidth: '174px'}}
                                                                              className={'left_link_man_name_style'}>{item.msgNum}条相关聊天记录</span>
                                                                    </div> : ''
                                                        }
                                                    </li>
                                                }
                                            })}
                                            {
                                                searchList.msgList && searchList.msgList.length >= 3 ?
                                                    <GlobalSearch ref={globalSearchModalRef}
                                                                  inputRef={chatCustomerBlur}
                                                                  clickJump={clickJump}
                                                                  modificationChatWxid={modificationChatWxid}
                                                    >
                                                        <span className={'reverl_all'}
                                                              style={{
                                                                  color: '#1673FF',
                                                                  paddingLeft: '12px',
                                                                  boxSizing: 'border-box'
                                                              }}
                                                            // 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
                                                              onClick={openFilterBox.bind(this, '3', searchName, wxid, wxid)}
                                                        >查看全部</span>
                                                    </GlobalSearch> : ''
                                            }
                                            <div className={'global_search_line'}
                                                 style={{margin: '16px 12px 0', width: 'calc(100% - 24px)'}}></div>
                                        </ul> : ''
                                }
                                <GlobalSearch ref={globalSearchModalRef} inputRef={chatCustomerBlur}
                                              ref={globalSearchModalRef} clickJump={clickJump}
                                              modificationChatWxid={modificationChatWxid}>
                                    <div className={'enter_info_global_search'}
                                        // 点击打开筛选的弹框 传4个值  类型,搜索的关键词,账号Id，当前活动聊天的账号
                                         onClick={openFilterBox.bind(this, '0', searchName, wxid, wxid)}>
                                        <img src={globalSearch} width={40}/>
                                        <div>
                                            <span>进入全局搜索</span>
                                            <span>查找联系人、群聊、聊天记录等</span>
                                        </div>
                                    </div>
                                </GlobalSearch>
                            </div>
                        }
                    </div>
                </div>
            </div>
            <Spin spinning={loading} indicator={''}>
                <div id={"conversations"} className={'all_conversations'} style={{paddingLeft: 'calc(260px - 100%)'}}>
                    <ul className={'individual_chat_messages'}>
                        {
                            data && data.map((item, index) => {
                                if (item.isTop == 1) {//先渲染置顶的
                                    return <RightClick key={item.conversationId} menuId={"leftClick" + index}
                                                       item={getItems(item, index)}>
                                        <li key={index}
                                            id={`chat${item.chat_wxid}`}
                                            className={item.checked ?
                                                'selected_dialogue chat_content across' :
                                                item.isTop == 1 ? 'stick chat_content across' :
                                                    'chat_content across'}
                                            onClick={selectedDialogue.bind(this, index, item)}
                                        >
                                            <div>
                                                {(item.notDisturb == 1 && item.notReadMsgNum != 0) ?
                                                    <div className={'do_not_disturb_message'}>
                                                        <div className={'private_group_chat'}
                                                             style={{marginRight: '10px'}}>
                                                            {item.avatar ?
                                                                <img src={item.avatar} style={{width: '40px'}}/> :
                                                                <>{
                                                                    item.isRoom == 0 ?
                                                                        <img src={defaultPersonage}
                                                                             className={'private_group_chat'}/> :
                                                                        <img src={defaultGroupChat}
                                                                             className={'private_group_chat'}/>
                                                                }</>}
                                                        </div>
                                                        <span></span>
                                                    </div> : item.hasNoRead == 1 ?
                                                        <div className={'do_not_disturb_message'}>
                                                            <div className={'private_group_chat'}
                                                                 style={{marginRight: '10px'}}>
                                                                {item.avatar ?
                                                                    <img src={item.avatar} style={{width: '40px'}}/> :
                                                                    <>{
                                                                        item.isRoom == 0 ?
                                                                            <img src={defaultPersonage}
                                                                                 className={'private_group_chat'}/> :
                                                                            <img src={defaultGroupChat}
                                                                                 className={'private_group_chat'}/>
                                                                    }</>}
                                                            </div>
                                                            <span></span>
                                                        </div> :
                                                        <Badge count={item.notReadMsgNum ? item.notReadMsgNum : ''}>
                                                            <div className={'private_group_chat'}>
                                                                {
                                                                    item.avatar ? <img src={item.avatar}
                                                                                       className={'private_group_chat'}/> :
                                                                        <>{
                                                                            item.isRoom == 0 ?
                                                                                <img src={defaultPersonage}
                                                                                     className={'private_group_chat'}/> :
                                                                                <img src={defaultGroupChat}
                                                                                     className={'private_group_chat'}/>
                                                                        }</>
                                                                }

                                                            </div>
                                                        </Badge>}
                                                <div className={'chat_content_message'}>
                                                    <span style={{height: '22px'}}>
                                                        {item.isRoom == 1 ?
                                                            <span
                                                                className={'private_chat_firm_name'}>{item.name}</span> :
                                                            item.isRoom == 0 ?
                                                                <>
                                                                    <span
                                                                        className={'private_chat_name'}>{item.name}</span>
                                                                    <span
                                                                        style={{maxWidth: item.name && item.name.length <= 3 ? '94px' : item.name && item.name.length == 4 ? '82px' : item.name && item.name.length == 5 ? '68px' : '54px'}}
                                                                        className={item.corpShortName == '微信' ? 'private_chat_firm_qy_name wx_name' : 'private_chat_firm_qy_name qy_name'}>{item.corpShortName ? <>@{item.corpShortName}</> : ''} </span>
                                                                </> : ''
                                                        }
                                                    </span>
                                                    <span className={'exceed_party'}>
                                                        {
                                                            item.isRoom == 1 ?
                                                                <>
                                                                    {item.lastMsg.senderName != '' && item.lastMsg.msgSimpleData != '' ?
                                                                        <>{item.lastMsg.senderName + '：'}{Util.displayingChatMessages(item.lastMsg)}</> : ''}
                                                                </> :
                                                                item.isRoom == 0 ?
                                                                    <>{Util.displayingChatMessages(item.lastMsg)}</> : ''
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={'show_hidden_content'}>
                                                {/*时间*/}
                                                <span
                                                    className={'show_timer'}>{Util.showTimer(item.lastMsg.msgTime)}</span>
                                                <span>
                                                    {
                                                        // 消息免打扰图标
                                                        item.notDisturb == 1 ?
                                                            <span
                                                                className={'no_disturbing'}><IconNoDisturbing/></span> :
                                                            <span></span>
                                                    }
                                                </span>
                                            </div>
                                        </li>
                                    </RightClick>
                                }
                            })
                        }
                        {
                            data && data.map((item, index) => {
                                if (item.isTop == 0) {//在渲染不置顶的
                                    return <RightClick key={item.conversationId} menuId={"leftClick" + index}
                                                       item={getItems(item, index)}
                                    >
                                        <li key={index}
                                            id={`chat${item.chat_wxid}`}
                                            className={item.checked ?
                                                'selected_dialogue chat_content across' :
                                                item.isTop == 1 ? 'stick chat_content across' :
                                                    'chat_content across'}
                                            onClick={selectedDialogue.bind(this, index, item)}
                                        >
                                            <div>
                                                {(item.notDisturb == 1 && item.notReadMsgNum != 0) ?
                                                    <div className={'do_not_disturb_message'}>
                                                        <div className={'private_group_chat'}
                                                             style={{marginRight: '10px'}}>
                                                            {item.avatar ?
                                                                <img src={item.avatar} style={{width: '40px'}}/> :
                                                                <>{
                                                                    item.isRoom == 0 ?
                                                                        <img src={defaultPersonage}
                                                                             className={'private_group_chat'}/> :
                                                                        <img src={defaultGroupChat}
                                                                             className={'private_group_chat'}/>
                                                                }</>}
                                                        </div>
                                                        <span></span>
                                                    </div> : item.hasNoRead == 1 ?
                                                        <div className={'do_not_disturb_message'}>
                                                            <div className={'private_group_chat'}
                                                                 style={{marginRight: '10px'}}>
                                                                {item.avatar ?
                                                                    <img src={item.avatar} style={{width: '40px'}}/> :
                                                                    <>{
                                                                        item.isRoom == 0 ?
                                                                            <img src={defaultPersonage}
                                                                                 className={'private_group_chat'}/> :
                                                                            <img src={defaultGroupChat}
                                                                                 className={'private_group_chat'}/>
                                                                    }</>}
                                                            </div>
                                                            <span></span>
                                                        </div> :
                                                        <Badge count={item.notReadMsgNum ? item.notReadMsgNum : ''}>
                                                            <div style={{width: '40px', height: '40px'}}>
                                                                {
                                                                    item.avatar ? <img src={item.avatar}
                                                                                       className={'private_group_chat'}/> :
                                                                        <>{
                                                                            item.isRoom == 0 ?
                                                                                <img src={defaultPersonage}
                                                                                     className={'private_group_chat'}/> :
                                                                                <img src={defaultGroupChat}
                                                                                     className={'private_group_chat'}/>
                                                                        }</>
                                                                }
                                                            </div>
                                                        </Badge>}
                                                <div className={'chat_content_message'}>
                                                    <span style={{height: '22px'}}>
                                                        {item.isRoom == 1 ?
                                                            <span
                                                                className={'private_chat_firm_name'}>{item.name}</span> :
                                                            item.isRoom == 0 ?
                                                                <>
                                                                    <span
                                                                        className={'private_chat_name'}>{item.name}</span>
                                                                    <span
                                                                        style={{maxWidth: item.name && item.name.length <= 3 ? '94px' : item.name && item.name.length == 4 ? '82px' : item.name && item.name.length == 5 ? '68px' : '54px'}}
                                                                        className={item.corpShortName == '微信' ? 'private_chat_firm_qy_name wx_name' : 'private_chat_firm_qy_name qy_name'}>{item.corpShortName ? <>@{item.corpShortName}</> : ''} </span>
                                                                </> : ''
                                                        }
                                                    </span>
                                                    <span className={'exceed_party'}>
                                                        {
                                                            item.isRoom == 1 ?
                                                                <>
                                                                    {item.lastMsg.senderName != '' && item.lastMsg.msgSimpleData != '' ?
                                                                        <>{item.lastMsg.senderName + '：'}{Util.displayingChatMessages(item.lastMsg)}</> : ''}
                                                                </> :
                                                                item.isRoom == 0 ?
                                                                    <>{Util.displayingChatMessages(item.lastMsg)}</> : ''
                                                        }
                                                    </span>
                                                </div>
                                            </div>
                                            <div className={'show_hidden_content'}>
                                                {/*时间*/}
                                                <span
                                                    className={'show_timer'}>{Util.showTimer(item.lastMsg.msgTime)}</span>
                                                <span>
                                                    {
                                                        // 消息免打扰图标
                                                        item.notDisturb == 1 ?
                                                            <span
                                                                className={'no_disturbing'}><IconNoDisturbing/></span> :
                                                            <span></span>
                                                    }
                                                </span>
                                            </div>
                                        </li>
                                    </RightClick>
                                }
                            })
                        }
                    </ul>
                    <BackTop style={{left: 450, bottom: 100}} target={() => document.getElementById('conversations')}>
                    </BackTop>
                </div>
            </Spin>
            <div className={'clear_all_conversations'} onClick={clearAllConversations}>
                <IconClean/>
                <span
                    style={{marginLeft: '6px'}}>
                    清空所有对话
                </span>
            </div>
            <ZkModal
                title={''} ref={clearAllRef} width={520} onOk={clearAll}
                className={'modal-right-btn'}
            >
                <div className={'modal-tip-content'}>
                    <img src={modal_warning}/>
                    <div>提示</div>
                </div>
                <div className={'send-modal-text'}>
                    {'确定清空所有对话吗？'}
                </div>
            </ZkModal>
            <ZkModal title={'新建群聊'} ref={aGroupChatRef} width={690}
                     className={'modal-right-btn'}
                     footer={[
                         <Button key="back" onClick={() => aGroupChatRef.current.hide()}>
                             取消
                         </Button>,
                         <Button key="submit" type="primary" loading={saveLoading} onClick={aGroupChatQuery}>
                             确定
                         </Button>,
                     ]}
            >
                <div className={'a_group_chat'}>
                    <ZkFormItem title={'群聊名称'} colon={true} titleWidth={'100px'} conWidth={'320px'}>
                        <div className={'task_name'}>
                            <Input
                                placeholder="请输入群聊名称"
                                maxLength={42}
                                value={groupName}
                                onChange={groupNameChange.bind(this)}
                            />
                            <span
                                className='word-limit'>{groupName ? groupName.length + '/42' : '0/42'}</span>
                        </div>
                    </ZkFormItem>
                    <ZkFormItem title={'添加的联系人'} colon={true} titleWidth={'100px'} conWidth={'524px'}>
                        <div className={'a_group_chat_add_linkman'}>
                            <div>
                                <Button type="primary" ghost onClick={myClient}>
                                    <IconAddLinkMan/>我的客户
                                </Button>
                                <Button type="primary" ghost onClick={memberCompanies}>
                                    <IconAddLinkMan/>企业成员
                                </Button>
                            </div>
                            <ul>
                                {
                                    selectLinkData && selectLinkData.map((item, index) => {
                                        return <li key={index}>
                                            <img src={item.avatar}/>
                                            <div>
                                                <span>{item.nickName}</span>
                                            </div>
                                            <span onClick={deleteLinkData.bind(this, index)}><IconDeletes/></span>
                                        </li>
                                    })
                                }
                                {
                                    selectFirmData && selectFirmData.map((item, index) => {
                                        return <li key={index}>
                                            <img src={item.avatar}/>
                                            <div>
                                                <span>{item.nickName}</span>
                                                {
                                                    item.isCorp == 1 ? <span>内部</span> : ''
                                                }
                                            </div>
                                            <span onClick={deleteFirm.bind(this, index)}><IconDeletes/></span>
                                        </li>
                                    })
                                }
                            </ul>
                        </div>
                    </ZkFormItem>
                </div>
            </ZkModal>
            <ZkModal
                title={'选择客户'}
                ref={myCustomerRef}
                width={'758px'}
                onOk={myClientQuery}
                onCancel={selectCustomerCancel}
                className={'modal-right-btn im-setting-modal'}
            >
                <MyCustomer activeState={'create'} ref={myClientRef} wxid={wxid} chat_wxid={''}/>
            </ZkModal>
            <ZkModal
                title={'选择企业成员'}
                ref={memberCompaniesRef}
                width={'688px'}
                onOk={memberCompaniesQuery}
                onCancel={selectFirmCustomerCancel}
                className={'modal-right-btn im-setting-modal'}
            >
                <MemberCompanies ref={frimDataRef} wxid={wxid} chat_wxid={''}/>
            </ZkModal>
            <ZkModal
                title={'通讯录发起聊天'}
                ref={addressBookRef}
                width={'610px'}
                footer={null}
                className={'modal-right-btn im-setting-modal'}
            >
                <AddressBook ref={addressListRef} wxid={wxid} chat_wxid={chat_wxid} data={data} getContent={getContent}
                             addressBookRef={addressBookRef.current}
                             modifiedTotalData={modifiedTotalData}
                />
            </ZkModal>
        </div>
    )
});

export default ConversationList